import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getHasDuplicatedMarks = store => store[NAME].hasDuplicatedMarks;
export const getAssistanceData = store => store[NAME].assistanceData;
export const getOpenCalendarList = store => store[NAME].openCalendarList;
export const getEmployeeList = store => store[NAME].employeeList;
export const getMapData = store => store[NAME].mapData;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;
export const getSchedules = store => store[NAME].schedules;